import React, { useRef } from 'react';
import ConsultasService from '../../services/ConsultaService';
import { IconButton } from '@mui/material';
import { MdFileOpen } from 'react-icons/md';

interface DescargarArchivoProps {
    url: string;
}

export const DescargarArchivoCertificado: React.FC<DescargarArchivoProps> = ({ url }) => {
    const service = new ConsultasService();

    function rutaArchivoAntiguo(certificado: string): string {
        // Primero extraemos el nombre del archivo
        const nombreArchivo = certificado.split('\\').pop() || certificado;

        // URL base donde están alojados los certificados antiguos
        const urlBase = 'https://gestionproyectos.espol.edu.ec/CERTIFICADOS/';

        // Construimos la URL final
        return urlBase + nombreArchivo;
    }

    const handleDescargar = async () => {
        const ipLocal = "192.168.1.125";
        console.log(url)
        if (!url.includes(ipLocal)) {
            // Si la ruta NO contiene la IP, abrir en nueva pestaña
            window.open(rutaArchivoAntiguo(url), '_blank');
        } else {
            // Si la ruta contiene la IP, hacer descarga vía fetch/axios
            await service.DescargarArchivo(url);
        }
    };



    return (
        <IconButton color='info' onClick={handleDescargar}><MdFileOpen /></IconButton>
    );
};